import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-3 mt-3" }
const _hoisted_2 = ["onDragstart"]

import { ProjectListed } from "@/apps/page/project/sidebar/sections/tool/project-listed.interface";
import AddTool from "@/apps/page/project/sidebar/sections/tool/AddTool.vue";
import { useMutations, useState } from "@/store/vuex-composition-mappers";
import { computed, ref } from "vue";
import { PAGE_SECTION_KINDS } from "@/apps/page/services/page.service";
import { CardEmpty } from "@easy/ui/cards";
import { useSections } from "@/apps/page/services/useSections";
import { InPageUsedTools } from "@/apps/page/page-project.interface";
import { t } from "@/i18n";
import { projectsService } from "@/shared/projects/projects.service";
import { useRouter } from "vue-router";
import { setupDragStart } from "@/apps/page/project/sidebar/sections/dragOverlay";


export default /*@__PURE__*/_defineComponent({
  __name: 'AddToolList',
  props: {
    projects: {},
    tool: {}
  },
  emits: ["dragStart"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const router = useRouter();
// @ts-expect-error
const { showModal } = useMutations(["showModal"]);
// @ts-expect-error (TODO: fix this)
const { page } = useState("page", ["page"]);
const { getSectionTypeByTool } = useSections();
const styleValues = computed(() => page.value.colors || {});

const toolRefs = ref<HTMLElement[]>([]);

const emptySection = computed(() => getSectionTypeByTool(props.tool));

async function handleDragStart(event: DragEvent, project: ProjectListed, index: number) {
    const toolElement = toolRefs.value[index];

    await setupDragStart(
        event,
        {
            type: PAGE_SECTION_KINDS.TOOL,
            data: project,
        },
        toolElement,
        {
            fallbackText: project.name,
        }
    );

    emit("dragStart");
}

function setToolRef(index: number, el: any) {
    if (el && el.$el) {
        toolRefs.value[index] = el.$el;
    } else if (el && el instanceof HTMLElement) {
        toolRefs.value[index] = el;
    }
}

function addNewProject() {
    const modalData = {
        type: "input",
        input: "",
        title: t("shared.list.name_project"),
        cancelBtn: t("shared.cancel"),
        actionBtn: t("shared.add"),
        callback: async () => {
            if (!modalData.input) {
                return;
            }
            const project = await projectsService.create({
                tool: props.tool,
                name: modalData.input,
            });
            // @ts-expect-error
            await router.push(`/${props.tool}/projects/${project?.uuid}?page=${page.value.uuid}`);
        },
    };
    showModal(modalData);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (project, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: project.uuid,
        class: "flex items-center flex-col gap-4 ct-ring-1 hover:ct-ring-brand cursor-move transition-all duration-200",
        draggable: "true",
        ref_for: true,
        ref: (el) => setToolRef(index, el),
        onDragstart: (e) => handleDragStart(e, project, index)
      }, [
        _createVNode(AddTool, {
          project: project,
          styleValues: styleValues.value,
          fontFamily: _unref(page).fontFamily,
          scrollAnimationType: _unref(page).settings?.scrollAnimationType
        }, null, 8, ["project", "styleValues", "fontFamily", "scrollAnimationType"])
      ], 40, _hoisted_2))
    }), 128)),
    (_ctx.projects.length === 0)
      ? (_openBlock(), _createBlock(_unref(CardEmpty), {
          key: 0,
          title: emptySection.value?.emptyTitle,
          subtitle: emptySection.value?.emptySubtitle,
          icon: emptySection.value?.icon,
          "cta-label": _ctx.$t('shared.add'),
          onAdd: addNewProject
        }, null, 8, ["title", "subtitle", "icon", "cta-label"]))
      : _createCommentVNode("", true)
  ]))
}
}

})